import { Course, SessionModuleItem } from "@sdk/lib/types/course";

export type ModuleLocation =
  | {
      kind: "session";
      sessionNumber: number;
      sessionTitle: string;
      sessionLabel: string;
    }
  | { kind: "menu-item"; pageTitle: string };

function itemKeys(item: SessionModuleItem): string[] {
  const moduleItem = item.module_item as { _id?: any } | undefined;
  const keys: string[] = [];
  const moduleItemId = moduleItem?._id?.toString();
  if (moduleItemId) keys.push(moduleItemId);
  const shellId = item.module_shell?._id?.toString();
  if (shellId) keys.push(shellId);
  return keys;
}

export function buildModuleLocationIndex(
  course: Course | undefined | null,
): Map<string, ModuleLocation> {
  const index = new Map<string, ModuleLocation>();
  if (!course) return index;

  const sessionLabel = course.session_list_title?.trim() || "Session";

  const register = (item: SessionModuleItem, location: ModuleLocation) => {
    for (const key of itemKeys(item)) {
      if (!index.has(key)) index.set(key, location);
    }
  };

  (course.session_list ?? []).forEach((session, i) => {
    const location: ModuleLocation = {
      kind: "session",
      sessionNumber: i + 1,
      sessionTitle: session.title?.trim() ?? "",
      sessionLabel,
    };
    for (const item of session.session_module_item_list ?? []) {
      register(item, location);
    }
  });

  for (const menuItem of course.course_menu_item_list ?? []) {
    const location: ModuleLocation = {
      kind: "menu-item",
      pageTitle: menuItem.title?.trim() ?? "",
    };
    for (const session of menuItem.menu_item_session_list ?? []) {
      for (const item of session.session_module_item_list ?? []) {
        register(item, location);
      }
    }
  }

  return index;
}

export function formatModuleLocation(location: ModuleLocation): string {
  if (location.kind === "session") {
    return `${location.sessionLabel} ${location.sessionNumber}`;
  }
  return `${location.pageTitle} (page)`;
}
